import { getDateFrom } from '../functions/format_date'
import Moment from 'moment'

export default {
  data: () => ({
    filter: {
      users: [],
      expensesCategories: [],
      expensesStatuses: [],
      date_from: Moment().startOf('month').format('MM/DD/YYYY'),
      date_to: Moment().endOf('month').format('MM/DD/YYYY')
    },
    users: []
  }),
  computed: {
    __usersIds () {
      let arr = []
      this.filter.users.map(user => {
        arr.push(user.id)
      })
      return arr
    },
    __expensesCategoriesIds () {
      let arr = []
      this.filter.expensesCategories.map(expensesCategory => {
        arr.push(expensesCategory.id)
      })
      return arr
    },
    __expensesStatusesIds () {
      let arr = []
      this.filter.expensesStatuses.map(expensesStatus => {
        arr.push(expensesStatus.id)
      })
      return arr
    }
  },
  methods: {
    __resetFilter (callback) {
      this.filter.users = []
      this.filter.projects = []
      this.filter.unitManagers = []
      this.filter.projectStatus = ''

      if (callback) {
        callback()
      }
    },
    __getDate (date, target) {
      let result = getDateFrom(date, target)
      if (target === 'from') {
        this.form.date_from = result
      } else {
        this.form.date_to = result
      }
    }
  }
}
